document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".video-faq").forEach((section) => {

    const bubble = section.querySelector(".video-faq__bubble");
    const bubbleClose = section.querySelector(".video-faq__bubble-close");
    const popup = section.querySelector(".video-faq__popup");
    const close = section.querySelector(".video-faq__close");

    const video = section.querySelector(".video-faq__video");
    const bubbleVideo = section.querySelector(".video-faq__bubble-video");

    const playBtn = section.querySelector(".faq-play");
    const muteBtn = section.querySelector(".faq-mute");
    const progress = section.querySelector(".faq-progress");
    const speed = section.querySelector(".faq-speed");

    const questions = section.querySelectorAll(".video-faq__question");

    /*
    =====================================================
    PERMANENTLY DISMISSED CHECK
    =====================================================
    */

    const dismissedKey = "videoFaqAssistantDismissed";

    if (localStorage.getItem(dismissedKey) === "true") {
      section.style.display = "none";

      if (video) {
        video.pause();
      }

      if (bubbleVideo) {
        bubbleVideo.pause();
      }

      return;
    }


    /*
    =====================================================
    PERMANENTLY CLOSE ASSISTANT
    =====================================================
    */

    if (bubbleClose) {

      bubbleClose.addEventListener("click", (e) => {

        e.preventDefault();
        e.stopPropagation();

        // Stop popup video
        if (video) {
          video.pause();
          video.currentTime = 0;
        }

        // Stop bubble video
        if (bubbleVideo) {
          bubbleVideo.pause();
          bubbleVideo.currentTime = 0;
        }

        // Close popup if open
        section.classList.remove("active");

        // Remember dismissal permanently
        localStorage.setItem(dismissedKey, "true");

        // Hide the entire assistant
        section.style.display = "none";

      });

    }


    /*
    =====================================================
    OPEN POPUP
    =====================================================
    */

    if (bubble) {

      bubble.addEventListener("click", () => {

        section.classList.add("active");

        if (video) {

          video.play().catch(() => {});

        }

      });

    }


    /*
    =====================================================
    CLOSE POPUP
    =====================================================
    */

    if (close) {

      close.addEventListener("click", () => {

        section.classList.remove("active");

        if (video) {
          video.pause();
        }

      });

    }


    /*
    =====================================================
    PLAY / PAUSE
    =====================================================
    */

    if (playBtn && video) {

      playBtn.addEventListener("click", () => {

        if (video.paused) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }

      });


      video.addEventListener("play", () => {

        playBtn.innerHTML = "❚❚";

      });


      video.addEventListener("pause", () => {

        playBtn.innerHTML = "▶";

      });

    }


    /*
    =====================================================
    MUTE / UNMUTE
    =====================================================
    */

    if (muteBtn && video) {

      muteBtn.addEventListener("click", () => {

        video.muted = !video.muted;

        muteBtn.innerHTML = video.muted ? "🔇" : "🔊";

      });

    }


    /*
    =====================================================
    SPEED
    =====================================================
    */

    if (speed && video) {

      speed.addEventListener("change", (e) => {

        video.playbackRate = parseFloat(e.target.value);

      });

    }


    /*
    =====================================================
    PROGRESS BAR
    =====================================================
    */

    if (video && progress) {

      video.addEventListener("timeupdate", () => {

        if (!video.duration) return;

        progress.value =
          (video.currentTime / video.duration) * 100;

      });


      progress.addEventListener("input", () => {

        if (!video.duration) return;

        video.currentTime =
          (progress.value / 100) * video.duration;

      });

    }


    /*
    =====================================================
    QUESTION CLICK
    =====================================================
    */

    questions.forEach((button) => {

      button.addEventListener("click", () => {

        questions.forEach((q) => {
          q.classList.remove("active");
        });

        button.classList.add("active");

        const src = button.dataset.video;

        if (!src || !video) return;

        const wasMuted = video.muted;
        const rate = video.playbackRate;

        video.pause();

        video.querySelectorAll("source").forEach((source) => {
          source.remove();
        });

        const source = document.createElement("source");

        source.src = src;
        source.type = "video/mp4";

        video.appendChild(source);

        video.load();

        video.muted = wasMuted;
        video.playbackRate = rate;

        video.play().catch(() => {});

      });

    });

  });

});